import {
  QUERY_PARAM_EXCLUDE_TAGS,
  QUERY_PARAM_INCLUDE_TAGS,
  QUERY_PARAM_SEARCH,
  urls
} from '@treneo/shared/constants';

export const buildTrainingsPath = (searchParams: URLSearchParams): string => {
  const q = searchParams.get(QUERY_PARAM_SEARCH);
  const includeTags = searchParams.get(QUERY_PARAM_INCLUDE_TAGS);
  const excludeTags = searchParams.get(QUERY_PARAM_EXCLUDE_TAGS);
  if (!q && !includeTags && !excludeTags) {
    return urls.homePage;
  }

  const params = new URLSearchParams();
  if (q) {
    params.set(QUERY_PARAM_SEARCH, q);
  }

  if (includeTags) {
    params.set(QUERY_PARAM_INCLUDE_TAGS, includeTags);
  }

  if (excludeTags) {
    params.set(QUERY_PARAM_EXCLUDE_TAGS, excludeTags);
  }

  return `${urls.homePage}?${params.toString()}`;
};
